module.exports = __webpack_public_path__ + "static/media/phone_idle.bd5e0e0a.svg";